import { network } from '@utils'
import { QueryFunction } from './root'

export type InvoicingBankAccountSource = 'ENABLE_BANKING' | 'HOLVI'

export interface IInvoicingBankAccount {
  id: string
  source: InvoicingBankAccountSource
  name: string | null
  bank_name: string
  iban: string | null
  bic: string | null
  currency: string
}

interface InvoicingBankAccountsProps {
  slug: string
}

export const fetchInvoicingBankAccounts: QueryFunction<
  InvoicingBankAccountsProps,
  IInvoicingBankAccount[]
> = async ({ slug }) => {
  const url = `/v1/integrations/business/${slug}/bank_accounts/`
  const { data } = await network.httpClient.request({
    url,
    method: 'GET'
  })
  return data
}
